import { graphql, useStaticQuery } from 'gatsby'

const locale = process.env.GATSBY_INTL_LOCALE

export const useInternalRoutesApiData = (locationPath) => {
  const { routesApi } = useStaticQuery(
    graphql`
      query {
        routesApi {
          values {
            lang
            internalRoutes {
              language_route
              generic_route
              href_langs {
                href_lang
                url
              }
            }
          }
        }
      }
    `
  )

  const routes =
    routesApi?.values?.find((item) => item?.lang === locale)?.internalRoutes ||
    []
  const currentRoute =
    routes?.find((item) => `/${item?.language_route}/` === locationPath) || null

  return { routes, currentRoute }
}
